<template>
  <div>
    <div
      class="input-wrapper all-day-wrapper position-relative select-group"
      @click.stop.prevent="showSelect = true"
    >
      <span class="ver-center">Add members</span>
      <transition name="zoom">
        <multi-select-vue v-if="showSelect" :hide-select="hideSelect" />
      </transition>
    </div>
  </div>
</template>

<script>
import MultiSelectVue from "../MultiSelect.vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showSelect: false
    };
  },
  components: {
    MultiSelectVue
  },
  methods: {
    hideSelect() {
      this.showSelect = false;
    }
  },
  computed: {
    ...mapGetters("group", {
      selected: "getSelected"
    })
  }
};
</script>

<style scoped>
div >>> .zoom-enter-active {
  animation: zoomIn 0.2s ease-in-out forwards;
}

div >>> .zoom-leave-active {
  animation: zoomOut 0.2s ease-in-out forwards;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

@keyframes zoomOut {
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
}
</style>
